import { apolloClient } from '@/plugins/apollo';
import {
  CreateDataExtractionValue,
  UpdateDataExtractionValue,
} from '@/graphql';
import { appendToListSubQueryCache } from '@/modules/cacheHelpers';
import { createDataExtractionValueInput } from '@/models/DataExtractionValue';

const actions = {
  async save(context, { reportId, fieldId, dataExtractionValue }) {
    const mutation = dataExtractionValue.id
      ? UpdateDataExtractionValue
      : CreateDataExtractionValue;
    const dataField = dataExtractionValue.id
      ? 'updateDataExtractionValue'
      : 'createDataExtractionValue';

    const response = await apolloClient.mutate({
      mutation,
      variables: {
        id: dataExtractionValue.id,
        report: reportId,
        field: fieldId,
        dataExtractionValue: createDataExtractionValueInput(
          dataExtractionValue
        ),
      },
      refetchQueries: [
        'GetDataExtractionPage',
        'GetConsensusReviewPage',
      ],
      awaitRefetchQueries: true,
      update(cache, response) {
        // Append the new value to the cache of DataExtractionReport.values
        const record = response.data[dataField];
        appendToListSubQueryCache(
          cache,
          reportId,
          'DataExtractionReport',
          'values',
          record
        );
      },
    });
    return response.data[dataField];
  },
};

export default {
  namespaced: true,
  actions,
};
